<template>
    <b-modal hide-footer size="xl" id="levelUsersModal" title="Users In Level">
        <b-overlay v-if="!hasMounted" :show="!hasMounted">
            <div style="height: 100px;"></div>
        </b-overlay>

        <div v-if="hasMounted">
            <b-alert :show="!hasUsers">
                <div class="card-title">No users added.</div>
            </b-alert>
            <webix-ui v-if="hasUsers && !show_form" :config="config" v-model="users"></webix-ui>
            <div v-if="show_form"> <!-- style="padding-left: 3rem; padding-right: 3rem;" -->
                <b-overlay :show="is_saving">
                    <b-form>
                        <b-row>
                            <b-col class="mb-3" cols="12">
                                <b-row>
                                    <b-col cols="6">
                                        <label for="">Name</label>
                                        <b-form-input v-model="params.name"></b-form-input>
                                    </b-col>
                                    <b-col cols="6">
                                        <label for="">Email</label>
                                        <b-form-input v-model="params.email"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col class="mb-3" cols="12">
                                <b-row>
                                    <b-col cols="6">
                                        <label for="">Contact Number</label>
                                        <b-form-input v-model="params.cell_no"></b-form-input>
                                    </b-col>
                                    <b-col cols="6">
                                        <label for="">Designation</label>
                                        <b-form-input v-model="params.designation"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col class="mb-3" cols="12">
                                <b-row>
                                    <b-col cols="6">
                                        <label for="">ID Number</label>
                                        <b-form-input v-model="params.id_number"></b-form-input>
                                    </b-col>
                                    <b-col cols="6">
                                        <label for="">Academic Qualifications</label>
                                        <b-form-input v-model="params.academic_qual"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-col class="mb-3" cols="12">
                                <b-row>
                                    <b-col cols="6">
                                        <label for="">Work Qualification</label>
                                        <b-form-input v-model="params.work_qual"></b-form-input>
                                    </b-col>
                                    <b-col cols="6">
                                        <label for="">Years Experience</label>
                                        <b-form-input v-model="params.years_experience"></b-form-input>
                                    </b-col>
                                </b-row>
                            </b-col>
                        </b-row>
                    </b-form>
                </b-overlay>
            </div>
        </div>

        <!-- Footer -->
        <hr style="margin-left: -1rem; margin-right: -1rem;">
        <div class="mt-2" v-if="!show_form" style="width: 100%;">
            <b-button @click="show_form = true;" variant="primary" style="float: right;" >Add New User</b-button>
            <b-button @click="$bvModal.hide('levelUsersModal')" class="me-2" style="float: right;">Close</b-button>
        </div>
        <div class="mt-2" v-if="show_form" style="width: 100%;" >
            <b-button @click="saveUser" variant="success" style="float: right;" >Save</b-button>
            <b-button @click="show_form = false;" class="me-2" variant="primary" style="float: right;">Back</b-button>
            <!--<b-button @click="$bvModal.hide('levelUsersModal')" style="float: right;">Close</b-button>-->
        </div>
    </b-modal>
</template>

<script>
/*eslint-disable-next-line*/
import _ from 'lodash'
import { clientAdminState, clientAdminMethods } from '@/state/helpers'
export default {
    data:() => ({
        params:{
            id: -1,
            level_id: '',
            name: '',
            email: '',
            cell_no: '',
            designation: '',
            id_number: '',
            academic_qual: '',
            work_qual: '',
            years_experience: '',
        },
        is_saving: false,
        show_form: false,
        hasMounted: false,
        config:{
            id: 'usersTable',
            view: 'datatable',
            css: "datatableUsers webix_header_border webix_data_border",
            select: 'row',
            autoheight: true,
            fillspace: true,
            data:[],
            columns:[
                { id: 'id', header:'', hidden: true},
                { id: 'name', header:'Name', fillspace: true},
                { id: 'email', header:'Email', fillspace: 0.7},
                { id: 'work_qualifications', header:'Qualifications', fillspace: 0.5},
                { id: 'years_experience', header:'Experience', fillspace: 0.5},
                { id: 'designation', header:'Email', fillspace: 0.5},
                { id: 'actions', header:'Actions', fillspace: 0.5, template:'Edit Delete'},
            ],
            on:{//eslint-disable-next-line
                onItemClick(id, e, node){
                    /*var el = this.$scope.$parent;
                    setTimeout(()=>{
                        if(el.clickedAction == false){
                            el.selectRow(id.row);
                        }
                    }, 50)
                    */
                }
            },
        },
    }),
    computed:{
        ...clientAdminState,
        hasUsers(){
            if(this.users_in_level == null){
                return false;
            }
            else if(this.users_in_level.length > 0){
                return true;
            }
            else{
                return false;
            }
        },
        users(){
            if(this.hasUsers){
                return this.users_in_level;
            }
            else{
                return [];
            }
        }
    },
    methods:{
        ...clientAdminMethods,

        saveUser(){
            this.is_saving = true;
            this.saveUserToLevel(this.params)
            .then(()=>{
                this.$swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'Saved User', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                this.is_saving = false;
                this.$bvModal.hide('levelUsersModal');
            })
            .catch(()=>{
                this.is_saving = false;
            })
        },
        debugLeadUser(){
            let params = {
                level_id: 256,
                user_id: 21,
            }
            this.saveLevelLead(params);
        }
    },
    mounted(){
        setTimeout(()=>{
            this.hasMounted = true;
        }, 500);
        this.params.level_id = Number(this.level_id);
    },
    beforeDestroy(){
        //this.clearLevelUsers();
    }
}
</script>

<style>

</style>